<template>
    <v-card>
        <v-card-title class="font-italic grey--text darken-3 text-uppercase">{{ $t('delivery') }}</v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12" md="3">
                    <v-text-field
                        :value="order.geo.name"
                        :label="$t('settlement')"
                        color="teal lighten-2"
                        disabled
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                    <v-text-field
                        v-model="data.address"
                        :label="$t('address')"
                        color="teal lighten-2"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                    <v-menu
                        ref="menu"
                        v-model="datePkr"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="formattedDate"
                                :label="$t('arriveDate')"
                                prepend-icon="mdi-calendar"
                                clearable
                                v-bind="attrs"
                                v-on="on"
                                color="teal lighten-2"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="data.deliveryDate"
                            color="teal lighten-2"
                            no-title
                        >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="teal lighten-2"
                                @click="datePkr = false"
                            >
                                {{ $t('close') }}
                            </v-btn>
                            <v-btn
                                text
                                color="teal lighten-2"
                                @click="$refs.menu.save(data.deliveryDate)"
                            >
                                {{ $t('set') }}
                            </v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
    import { MixinOrderInfo } from '../../../mixins';

    export default {
        name: 'DeliveryInfo',
        mixins: [MixinOrderInfo],
        data() {
            return {
                datePkr: false,
                key: 'deliveryInfo',
            }
        },
        computed: {
            formattedDate: {
                get() {
                    return this.data.deliveryDate
                        ? new Date(this.data.deliveryDate).toLocaleDateString()
                        : this.$t('asSoonPossible');
                },
                set(value) {
                    this.data.deliveryDate = value;
                },
            },
        },
        methods: {
            orderHandle(value) {
                const { geo, address, deliveryDate } = value;
                this.data = {
                    address,
                    deliveryDate,
                    geo: geo.id,
                };
            },
        },
    }
</script>

<style scoped>

</style>
